var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login flex-center"},[_c('v-card',{staticClass:"modal modal-round"},[_c('div',{staticClass:"logo-wrapper flex-center"},[_c('img',{staticClass:"logo",attrs:{"src":"/images/logo.svg","alt":"wifeed-logo"}})]),_c('h1',[_vm._v("\n      Link inválidado com sucesso!\n    ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }